<template>
    <div style="text-align: left;" class="mx-2 mx-md-0">
        <div
          v-if="isMobile"
          class="d-flex justify-content-between align-items-center mb-2 py-2"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            @click="filtersVisible = !filtersVisible"
          >
            <b-icon-funnel-fill class="mr-1" />
            {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
          </b-button>
        </div>

        <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;">
            <div style="margin-bottom: 5px;">
                <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>SELECT DATE RANGE</div>
                        <b-input
                            id="dates"
                            size="lg"
                            variant="dark"
                            :placeholder="[query.startDate, query.endDate].join(' - ')"
                            style="display: inline-block; width: 220px; font-size: 14px; font-weight: bold;"
                            class="responsive-input"
                            autocomplete="off"
                        ></b-input>
                        <b-button size="sm" variant="dark" @click="search_dates" class="mt-1 mt-md-0">SEARCH</b-button>
                    </div>

                    <div style="display: inline-block; vertical-align: top;" v-if="query.startDate && query.endDate">
                        <div>SELECT ORDER TYPE</div>
                        <b-form-select size="lg" :options="order_types" v-model="order_type"
                            style="width: 180px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- TYPE --</b-form-select-option>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div style="display: inline-block; vertical-align: top;" v-if="query.startDate && query.endDate">
                        <div>SELECT STATE</div>
                        <b-form-select size="lg" :options="states_dict" v-model="state"
                            style="width: 180px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- STATE --</b-form-select-option>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-alert>

                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>SELECT LOCATION</div>
                        <b-form-select size="lg" :options="packet.locations" v-model="location_filter"
                            style="width: 180px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- ITEM LOCATION --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-alert>

                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>SELECT DROP LOCATION</div>
                        <b-form-select size="lg" :options="packet.locations" v-model="drop_location_filter"
                            style="width: 180px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- DROP LOCATION --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-alert>
            </div>
        </b-collapse>

        <b-card no-body>
            <div style="min-height: 500px; max-height: 1000px; overflow-y: scroll; height: 100%;">
                <div style="border: 1px solid gray; padding: 10px;">
                    <div style="width: 100%; height: 100%;" v-if="items_being_loaded">
                        <loading :active="true" :can-cancel="false" :is-full-page="false">
                        </loading>
                    </div>

                    <div v-else>
                        <div v-if="items.length > 0" style="position: relative; overflow-x: auto;">
                            <div style="display: inline-block; vertical-align: top; margin: 5px;">
                                <h5 style="z-index:100; font-family: courier; font-weight: bold;">
                                    PICKLIST FOR {{ query.startDate }} TO {{ query.endDate }}
                                </h5>
                            </div>

                            <div style="display: inline-block; vertical-align: top; margin: 5px;">
                                <download-csv class="btn" :data="get_csv_data()"
                                    style="border: 1px solid black; width: 180px; background: black; color: white; "
                                    :name="get_csv_filename()">

                                    DOWNLOAD EXCEL

                                </download-csv>
                                <b-button
                                    size="md"
                                    variant="success"
                                    class="ml-2"
                                    :disabled="!showSaveButton"
                                    @click="save_selected_pickup_items"
                                >
                                    {{ saveButtonText }}
                                </b-button>
                            </div>
                            <div v-if="selectedItems.length > 1" style="position: sticky; width:100%; top: 0; background: white; z-index: 100; padding: 5px; border-bottom: 1px solid #ccc;">
                                Assign truck to all selected:
                                <b-form-select
                                    size="sm"
                                    style="width: 150px; display: inline-block; margin-left: 10px;"
                                    :options="trucks"
                                    v-model="commonTruck"
                                    @change="update_selected_trucks_stats()"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null">Select Truck</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                            <table style="width: 100%;">
                                <thead>
                                    <tr v-for="item, idx in displayItems" v-if="allowed(item)"
                                        :class="{ 'non-selectable': !isSelectable(item) }">
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                    <tr style="background-color: black; color: white;">
                                        <th class="ipt_tdr"
                                            style="min-width: 30px; text-align: center; background-color: black; color: white;">
                                            <input type="checkbox" v-model="selectAll" @change="toggleSelectAll">
                                        </th>
                                        <th class="ipt_tdr" @click="sortby('invoice_id')"
                                            style="background-color: black; color: white;">
                                            INVOICE #
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('product_name')"
                                            style="min-width: 200px; background-color: black; color: white;">
                                            PRODUCT NAME
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('product_sku')"
                                            style="background-color: black; color: white;">
                                            PRODUCT SKU
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('outgoing_type')"
                                            style="background-color: black; color: white;">
                                            ORDER TYPE
                                        </th>

                                        <th class="ipt_tdr" style="background-color: black; color: white;">
                                            QTY
                                        </th>

                                        <th class="ipt_tdr" style="background-color: black; color: white;"
                                            @click="sortby('state')">
                                            STATUS
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('pickup_truck', packet.trucksdict)"
                                            style="background-color: black; color: white;">
                                            TRNSFR TRUCK
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('ship_locsub')"
                                            style="background-color: black; color: white;">
                                            PICK LOCATION
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('drop_locsub')"
                                            style="background-color: black; color: white;">
                                            DROP LOCATION
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item, idx in displayItems" v-if="allowed(item)">
                                        <td class="ipt_tdr" style="text-align: center;">
                                            <input
                                                type="checkbox"
                                                v-model="selectedItems"
                                                :value="item"
                                                :disabled="!isSelectable(item)"
                                            >
                                        </td>
                                        <td class="ipt_tdr" style="font-size: 12px;">
                                            {{ item.invoice_id }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ (item.product_name || item.product_sku) }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ (item.product_sku || '').toUpperCase() }}
                                        </td>

                                        <td class="ipt_tdr"
                                            :style="{ 'background-color': get_order_type_color(item.order_type, item.outgoing_type) }">
                                            {{ (item.outgoing_type || item.order_type || '').toUpperCase() }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ item.quantity }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ getStateText(item.state) }}
                                        </td>

                                        <td class="ipt_tdr">
                                            <b-form-select 
                                                size="sm" 
                                                style="width: 130px;" 
                                                :options="trucks"
                                                v-model="item.pickup_truck"
                                                :disabled="!isEditable(item)"
                                                @change="markItemModified(item)"
                                            >
                                            </b-form-select>
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ getLocationDisplay(item.ship_locsub) }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ getLocationDisplay(item.drop_location) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ItemComments from '@/components/importables/ItemComments'
import mappings from '@/utilities/mappings'
import { BIconFunnelFill } from "bootstrap-vue";

export default {
    name: "AdminToolsProcessTransferPickups",
    components: { flatPickr, Loading, ItemComments },
    data: function () {
        return {
            packet: {},
            all_loc_inventory_dict: {},
            states_dict: mappings.states_dict || [],
            state: null,
            items: [],
            originalValues: {},
            filteredItems: [],
            // Date range object
            query: {
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD')
            },
            location_filter: null,
            drop_location_filter: null,
            pick_truck_filter: null,
            manual_location_id: null,
            manual_truck_id: null,
            trucks: [],
            trucks_dict: {},
            trucks_being_loaded: true,
            items_being_loaded: false,
            trucks_stats: {},
            default_locsubs: [],
            drop_locsub: null,
            ship_locsub: null,
            comments_dict: {},
            item_comments_invoice_id: null,
            item_comments_itemid: null,
            sort_asc: true,
            default_location_id: null,
            order_types: [
                { value: 'store_transfer_order', text: 'STORE TRANSFER' },
            ],
            order_type: null,
            selectAll: false,
            selectedItems: [],
            commonTruck: null,
            originalTrucks: {},
            filtersVisible: true,
            isMobile: false,
        }
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        },
        getStateText(stateValue) {
            // Convert to number and handle null/undefined
            const stateNum = parseInt(stateValue);

            // Check if the state exists in mapping
            if (this.states_dict && this.states_dict[stateNum] !== undefined) {
                return this.states_dict[stateNum];
            }

            // Fallback for unknown states
            console.warn('Unknown state value:', stateValue, 'Number:', stateNum);
            return `UNKNOWN (${stateValue})`;
        },
        getLocationDisplay: function(locsub) {
            if (!locsub && locsub !== 0) return "N/A";

            // Convert to string if it's a number
            const locsubStr = String(locsub);

            if (locsubStr === "0") {
                return "MECCA WHOLESALE";
            }

            let locationId;
            if (locsubStr.includes('|')) {
                locationId = locsubStr.split('|')[0];
            } else {
                locationId = locsubStr;
            }

            if (this.packet.locationsdict && this.packet.locationsdict[locationId]) {
                return this.packet.locationsdict[locationId];
            }

            if (this.packet.locsubsdict && this.packet.locsubsdict[locsubStr]) {
                return this.packet.locsubsdict[locsubStr];
            }

            const location = this.packet.locations.find(loc => loc.value == locationId);
            if (location) {
                return location.text;
            }

            return locsubStr;
        },
        markItemModified: function(item) {
            // This will trigger the save button to show
            if (!this.originalValues[item.product_sku]) {
                this.originalValues[item.product_sku] = {
                    pickup_truck: item.pickup_truck,
                    reserved_locsub: item.reserved_locsub,
                    shipping_location: item.shipping_location,
                    locsub: item.locsub,
                    ship_locsub: item.ship_locsub,
                    drop_locsub: item.drop_locsub,
                    outgoing_type: item.outgoing_type
                };
            }
        },
        isSelectable: function(item) {
            // Only allow selection for states 9, -9, 10, -10 (adjust as needed for transfer orders)
            const state = Number(item.state);
            const allowedStates = [9, -9, 10, -10, 0, 2, -2, 3, -3]; // Include common transfer order states
            return allowedStates.includes(state);
        },

        isEditable: function(item) {
            // Only allow editing for selectable states
            const state = Number(item.state);
            const allowedStates = [9, -9, 10, -10, 0, 2, -2, 3, -3];
            return allowedStates.includes(state);
        },

        filterItems: function () {
            if (!Array.isArray(this.items)) {
                this.filteredItems = [];
                return;
            }

            this.filteredItems = this.items.filter(item => {
                if (!item) return false;

                const orderTypeMatch =
                    this.order_type === null ||
                    item.order_type === this.order_type;

                const stateMatch =
                    this.state === null ||
                    Number(item.state) === Number(this.state);

                return orderTypeMatch && stateMatch;
            });
        },
        concater: function (items) {
            let out = items.join("|")
            return out
        },
        allowed: function (item) {
            let status = true;
            if (this.location_filter != null) {
                if (item.pick_location_id != this.location_filter) {
                    status = false;
                }
            }

            if (this.drop_location_filter != null) {
                if (item.ship_locsub && parseInt(item.ship_locsub.split("|")[0], 10) !== this.drop_location_filter) {
                    status = false;
                }
            }

            if (this.pick_truck_filter != null) {
                if (item.pickup_truck != this.pick_truck_filter) {
                    status = false;
                }
            }

            if (item.quantity <= 0) {
                status = false;
            }

            return status
        },
        search_dates: function(e) {
            if (e) {
                e.preventDefault();
            }

            if (!this.query.startDate || !this.query.endDate) {
                this.$bvToast.toast(
                    "Please select a date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                return;
            }

            this.get_pick_items_for_date();
        },
        get_pick_items_for_date: function() {
            let path = "/api/sales/get_transfer_pickup_items_date_range/"
            let data = {
                startDate: this.query.startDate,
                endDate: this.query.endDate,
            }
            let that = this;

            let s = function(response) {
                if (response.data.result) {
                    that.items = response.data.result.map(item => {
                        let shippingLocsub = item.shipping_location;
                        if (shippingLocsub && !shippingLocsub.includes('|')) {
                            shippingLocsub = shippingLocsub + "|131";
                        }

                        return {
                            invoice_id: item.transfer_order_id || item.invoice_id,
                            product_sku: item.product_sku,
                            product_name: item.product_name,
                            quantity: item.quantity,
                            quantity_received: item.quantity_received,
                            outgoing_type: item.outgoing_type || 'store_transfer',
                            ship_locsub: item.ship_locsub || shippingLocsub,
                            reserved_locsub: item.reserved_locsub,
                            shipping_location: shippingLocsub,
                            locsub: item.locsub,
                            drop_location: item.drop_location,
                            drop_locsub: item.drop_locsub,
                            pickup_truck: item.truck,
                            state: item.state || 0,
                            cubes: item.cubes,
                            loading: item.loading,
                            order_type: item.outgoing_type || 'store_transfer_order',
                            pick_location_id: item.pick_location_id,
                            itemid: item.id || item.itemid
                        };
                    });

                    that.originalValues = {};
                    that.items.forEach(item => {
                        that.originalValues[item.product_sku] = {
                            pickup_truck: item.pickup_truck,
                            reserved_locsub: item.reserved_locsub,
                            shipping_location: item.shipping_location,
                            locsub: item.locsub,
                            drop_locsub: item.drop_locsub,
                            ship_locsub: item.ship_locsub,
                            outgoing_type: item.outgoing_type
                        };
                    });

                    that.update_trucks_stats();
                    that.filterItems();
                    that.selectedItems = [];
                    that.selectAll = false;
                    that.commonTruck = null;
                } else {
                    console.log(response.data.error)
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
                that.items_being_loaded = false;
            }

            let f = function(error) {
                console.log(error, "ees")
                that.$bvToast.toast(
                    "Error loading transfer orders for date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                that.items_being_loaded = false;
            }

            this.items_being_loaded = true;
            Requestor.postSync(path, data, s, f);
        },

        isItemModified: function(item) {
            if (!this.originalValues[item.product_sku]) return true;

            const original = this.originalValues[item.product_sku];
            return (
                item.pickup_truck !== original.pickup_truck ||
                item.reserved_locsub !== original.reserved_locsub ||
                item.shipping_location !== original.shipping_location ||
                item.locsub !== original.locsub ||
                item.ship_locsub !== original.ship_locsub ||
                item.drop_locsub !== original.drop_locsub ||
                item.outgoing_type !== original.outgoing_type
            );
        },
        get_order_type_color: function (order_type, outgoing_type) {
            // Use outgoing_type if available, otherwise fall back to order_type
            const type = (outgoing_type || order_type || '').toUpperCase();

            if (type === 'STORE_PICKUP' || type === 'STORE_PICKUP_TRANSFER') {
                return '#c5e1a5';
            }
            else if (type === 'HOME_DELIVERY') {
                return '#b3e5fc';
            }
            else if (type === 'STORE_TRANSFER' || type === 'STORE_TRANSFER_ORDER') {
                return '#ffd54f';
            }
            else {
                return '#efefef';
            }
        },
        update_trucks_stats: function (item) {
            let that = this;
            this.trucks_stats = {}
            for (var i = 0; i < this.items.length; i++) {
                let it = this.items[i];
                let truck = it.pickup_truck;

                if (truck in this.trucks_stats) {
                    this.trucks_stats[truck] += (parseInt(it.cubes) || 0);
                }
                else {
                    this.trucks_stats[truck] = (parseInt(it.cubes) || 0);
                }
            }

            for (var i = 0; i < this.trucks.length; i++) {
                this.trucks[i].cube_count = 0;
                this.trucks[i].cube_count = parseInt(this.trucks_stats[this.trucks[i].value]);
            }

            if (item) {
                this.save_pickup_item(item);
            }
            return
        },
        update_selected_trucks_stats() {
          if (this.selectedItems.length > 1 && this.commonTruck) {
            this.selectedItems.forEach(selected => {
              const index = this.items.findIndex(it => it.itemid === selected.itemid);
              if (index === -1) return;

              const current = this.items[index];

              if (!this.isEditable(current) || current.state == 5) return;

              if (!this.originalTrucks[selected.itemid]) {
                this.originalTrucks[selected.itemid] = selected.pickup_truck;
              }

              selected.pickup_truck = this.commonTruck;
              current.pickup_truck = this.commonTruck;
            });
          }
        },
        save_pickup_item: function(item) {
            if (!this.isItemModified(item)) {
                this.$bvToast.toast(
                    "No changes to save for this item.",
                    { title: "Info", autoHideDelay: 1500, variant: "info" }
                );
                return;
            }

            let path = "/api/sales/update_transfer_order_items_process_pickups/"
            let data = {
                transfer_order_id: item.invoice_id,
                product_sku: item.product_sku,
                truck: item.pickup_truck,
                reserved_locsub: item.reserved_locsub,
                shipping_location: item.shipping_location,
                locsub: item.locsub,
                ship_locsub: item.ship_locsub,
                drop_locsub: item.drop_locsub,
                outgoing_type: item.outgoing_type,
                status: item.state
            }

            let that = this;
            let s = function(response) {
                if (!response.data.error) {
                    // Update original values after successful save
                    that.originalValues[item.product_sku] = {
                        pickup_truck: item.pickup_truck,
                        reserved_locsub: item.reserved_locsub,
                        shipping_location: item.shipping_location,
                        locsub: item.locsub,
                        ship_locsub: item.ship_locsub,
                        drop_locsub: item.drop_locsub,
                        outgoing_type: item.outgoing_type
                    };

                    that.$bvToast.toast(
                        "Updated transfer order item successfully.",
                        { title: "Success", autoHideDelay: 1500, variant: "success" }
                    );
                } else {
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
            }

            let f = function(error) {
                that.$bvToast.toast(
                    "Error updating transfer order item.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
            }

            Requestor.postAsync(path, data, s, f);
        },
        save_selected_pickup_items: function() {
            let path = "/api/sales/update_transfer_order_items_process_pickups/"

            const validSelectedItems = this.selectedItems.filter(item =>
                this.isSelectable(item) && this.isItemModified(item) && this.isEditable(item)
            );

            if (validSelectedItems.length === 0) {
                this.$bvToast.toast(
                    "No valid changes to save in selected items.",
                    { title: "Info", autoHideDelay: 1500, variant: "info" }
                );
                return;
            }

            let that = this;
            let savedCount = 0;
            let errorCount = 0;

            validSelectedItems.forEach(item => {
                let data = {
                    invoice_id: item.invoice_id,
                    product_sku: item.product_sku,
                    truck: item.pickup_truck,
                    reserved_locsub: item.reserved_locsub,
                    locsub: item.locsub,
                    shipping_location: item.shipping_location,
                    ship_locsub: item.ship_locsub,
                    drop_locsub: item.drop_locsub,
                    outgoing_type: item.outgoing_type
                };

                console.log("Sending data to backend:", data);

                let s = function(response) {
                    if (!response.data.error) {
                        // Update original values after successful save
                        that.originalValues[item.product_sku] = {
                            pickup_truck: item.pickup_truck,
                            reserved_locsub: item.reserved_locsub,
                            shipping_location: item.shipping_location,
                            locsub: item.locsub,
                            ship_locsub: item.ship_locsub,
                            drop_locsub: item.drop_locsub,
                            outgoing_type: item.outgoing_type
                        };
                        savedCount++;

                        if (savedCount + errorCount === validSelectedItems.length) {
                            that.$bvToast.toast(
                                `Updated ${savedCount} of ${validSelectedItems.length} item(s).`,
                                { title: "Success", autoHideDelay: 1500, variant: "success" }
                            );

                            that.selectedItems = [];
                            that.selectAll = false;
                            that.commonTruck = null;
                        }
                    } else {
                        errorCount++;
                        that.$bvToast.toast(
                            `Error updating item ${item.invoice_id}: ${response.data.error}`,
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                };

                let f = function(error) {
                    errorCount++;
                    that.$bvToast.toast(
                        `Error updating item ${item.invoice_id}`,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                };

                Requestor.postAsync(path, data, s, f);
            });
        },
        fetch_prereqs: function (order_type) {
            let that = this;
            let prereqs = [
                {
                    path: "/api/user/get_trucks/",
                    data: {},
                    type: "",
                    executable: Requestor.getAsync,
                    s: function (response) {
                        if (response.data.result) {
                            that.trucks = response.data.result.filter(item => item.userrole === "housetruck").map(function (d) {
                                return {
                                    value: d.id,
                                    text: d.username,
                                    cube_count: 0
                                }
                            });

                            that.trucks.forEach((el, index) => that.trucks_dict[el.value] = el.text);

                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                { title: "Error", autoHideDelay: 1500, variant: "warning" }
                            );
                        }
                        that.trucks_being_loaded = false;
                    },
                    f: function (error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading trucks.",
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                },
                {
                    path: "/api/inventory/get_all_loc_inventory_dict/",
                    data: {},
                    type: "",
                    executable: Requestor.getAsync,
                    s: function (response) {
                        if (response.data.result) {
                            that.all_loc_inventory_dict = response.data.result;
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                { title: "Error", autoHideDelay: 1500, variant: "warning" }
                            );
                        }
                    },
                    f: function (error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading inventory.",
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                },
                {
                    path: "/api/sales/get_default_locsubs/",
                    data: {},
                    type: "",
                    executable: Requestor.getAsync,
                    s: function (response) {
                        if (response.data.result.length > 0) {
                            that.default_locsubs = response.data.result;
                            that.drop_locsub = that.default_locsubs.filter(function (d) { return d.name == 'drop_locsub' })[0].locsub;
                            that.default_location_id = parseInt(that.drop_locsub.split("|")[0])
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                { title: "Error", autoHideDelay: 1500, variant: "warning" }
                            );
                        }
                    },
                    f: function (error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading default locations.",
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                },
            ];

            for (var i = 0; i < prereqs.length; i++) {
                let path = prereqs[i]["path"];
                let data = prereqs[i]["data"];
                let s = prereqs[i]["s"];
                let f = prereqs[i]["f"];
                let type = prereqs[i]["type"];
                if (type == "secure") {
                    prereqs[i]["executable"](path, data, this, s, f);
                }
                else {
                    prereqs[i]["executable"](path, data, s, f);
                }
            }
        },
        sortby: function (key, mapper) {
            if (this.sort_asc) {
                this.items = Requestor.sort(this.items, key, mapper)
            }
            else {
                this.items = Requestor.sort_reverse(this.items, key, mapper)
            }
            this.sort_asc = !this.sort_asc;
        },
        get_csv_data: function () {
            let data = []
            let items = this.items;
            let that = this;
            if (items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    let row = items[i];
                    data.push(
                        {
                            invoice_id: row.invoice_id,
                            product_name: row.product_name,
                            product_sku: row.product_sku,
                            quantity: row.quantity,
                            outgoing_type: row.outgoing_type,
                            pick_location: this.getLocationDisplay(row.ship_locsub),
                            drop_location: this.getLocationDisplay(row.drop_location),
                            pickup_truck: this.packet.trucksdict[row.pickup_truck],
                            status: this.getStateText(row.state)
                        }
                    )
                }
            }
            return data
        },
        get_csv_filename: function () {
            let startDate = this.query.startDate;
            let endDate = this.query.endDate;
            return `TRANSFER_PICKLIST_${startDate}_TO_${endDate}.csv`;
        },
        isDisabled: function (item) {
            return !this.isEditable(item);
        },
        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedItems = this.displayItems.filter(item => this.isSelectable(item));
            } else {
                this.selectedItems = [];
            }
        },
        initDatePicker: function() {
            const Lightpick = require('lightpick');
            let that = this;
            
            var picker = new Lightpick({
                field: document.getElementById('dates'),
                singleDate: false,
                repick: true,
                format: 'YYYY-MM-DD',
                onSelect: function(start, end) {
                    that.query.startDate = start ? start.format('YYYY-MM-DD') : '';
                    that.query.endDate = end ? end.format('YYYY-MM-DD') : '';
                    // Auto-search when date range is selected
                    if (start && end) {
                        that.get_pick_items_for_date();
                    }
                }
            });
            
            // Set initial date range to today
            picker.setDate(moment().toDate());
        },
    },

    computed: {
        selectAll: {
            get() {
                const selectableItems = this.displayItems.filter(item => this.isSelectable(item));
                return selectableItems.length > 0 &&
                    this.selectedItems.length === selectableItems.length;
            },
            set(value) {
                if (value) {
                    this.selectedItems = this.displayItems.filter(item => this.isSelectable(item));
                } else {
                    this.selectedItems = [];
                }
            }
        },
        displayItems() {
            if ((this.order_type !== null || this.state !== null) &&
                this.filteredItems.length === 0) {
                return [];
            }

            return (this.order_type !== null || this.state !== null)
                ? this.filteredItems
                : this.items;
        },
        showSaveButton() {
            if (this.selectedItems.length === 0) return false;

            return this.selectedItems.some(item =>
                this.isItemModified(item) && this.isEditable(item)
            );
        },
        saveButtonText() {
            if (this.selectedItems.length === 0) return "Save";

            const modifiedCount = this.selectedItems.filter(item =>
                this.isItemModified(item) && this.isEditable(item)
            ).length;

            if (modifiedCount === 1) return "Save Item";
            return `Save ${modifiedCount} Items`;
        },
    },
    watch: {
        state() {
            this.filterItems();
        },
        order_type() {
            this.filterItems();
        },
        selectedItems(newVal) {
            this.selectAll = newVal.length === this.displayItems.length && this.displayItems.length > 0
        },
        displayItems() {
            this.selectAll = this.selectedItems.length === this.displayItems.length && this.displayItems.length > 0
        },
        items: {
            deep: true,
            handler(newItems) {
                newItems.forEach(item => {
                    if (!this.originalValues[item.product_sku]) {
                        this.originalValues[item.product_sku] = {
                            pickup_truck: item.pickup_truck,
                            reserved_locsub: item.reserved_locsub,
                            shipping_location: item.shipping_location,
                            locsub: item.locsub,
                            drop_locsub: item.drop_locsub,
                            ship_locsub: item.ship_locsub,
                            outgoing_type: item.outgoing_type
                        };
                    }
                });
            }
        },
    },
    mounted: function() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        this.initDatePicker();
        // Auto-load items for today's date range on mount
        this.get_pick_items_for_date();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    created: function () {
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);
        this.packet.locsubsdict["-1|-1"] = "CUSTOMER HOME";
        this.fetch_prereqs();
    }
}
</script>

<style scoped>
.non-selectable {
    opacity: 0.6;
    background-color: #f5f5f5;
}
.ipt_tdr {
    font-family: roboto !important;
    font-size: 13px;
    background: white;
}

.pcol {
    padding: 5px;
}

.card-body {
    padding: 5px;
}

@media (max-width: 600px) {
    .responsive-input {
        width: 100% !important;
        display: block !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsStoreTransfers2.vue